import { render } from "./Stat.vue?vue&type=template&id=4d882dd4&scoped=true"
import script from "./Stat.vue?vue&type=script&lang=js"
export * from "./Stat.vue?vue&type=script&lang=js"

import "./Stat.vue?vue&type=style&index=0&id=4d882dd4&scoped=true&lang=css"

import exportComponent from "/var/lib/docker/jenkins_home/workspace/spider-web-gp-tools-s3-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d882dd4"]])

export default __exports__